import type { z } from 'zod';
import { ThumbsUp } from 'lucide-react';

import type { ReportSchema } from '@ballerine/common';

import { DigitalFootprintSocialMedia } from '@/components/templates/shared';
import { ReportWrapper } from '../components/ReportWrapper';

type ReportData = NonNullable<z.infer<typeof ReportSchema>['data']>;
type SocialMediaSectionProps = {
  facebookPage?: ReportData['facebookPage'] | null;
  instagramPage?: ReportData['instagramPage'] | null;
  linkedinPage?: ReportData['linkedinPage'] | null;
  tiktokPage?: ReportData['tiktokPage'] | null;
  twitterPage?: ReportData['twitterPage'] | null;
};

export const SocialMediaSection = ({
  facebookPage,
  instagramPage,
  twitterPage,
  linkedinPage,
  tiktokPage,
}: SocialMediaSectionProps) => {
  return (
    <ReportWrapper
      title="Social Media"
      Icon={ThumbsUp}
      tooltip="Social media presence verification and activity analysis across major platforms."
      showTooltip={false}
    >
      <DigitalFootprintSocialMedia
        facebook={facebookPage ?? null}
        instagram={instagramPage ?? null}
        twitter={twitterPage ?? null}
        linkedin={linkedinPage ?? null}
        tiktok={tiktokPage ?? null}
      />
    </ReportWrapper>
  );
};
